  import React, { useState } from "react";
import Home from "../Home";
import * as image from "../../resources/images";
import { SelectPicker, Rating } from "../../utils/Packages";
import RoundProgress from "../controls/RoundProgress";
import Link from "antd/es/typography/Link";
import Sidebar from "./Sidebar";
import CourseRatings from "../controls/CourseRatings";
import { CourseCard } from "../dimensions/activity";
import SidebarNew from "./SidebarNew";
import { Header } from "rsuite";
import Topbar from "./Topbar";
import NewTopbar from "./NewTopbar";
import { Line } from "rc-progress";
import SecHeader from "./SecHeader";

const CourseStaticPage = () => {
  return (
    <>
     <div className="RootContent ">
    <SidebarNew />
    <div className="main_content">
     <NewTopbar />
     {/* <div className="Content_part flexsix">
      <div className="leftpannel">
      <div className="myplan_listitems">
        <div className="panneltitles ">
          <div className="contenttitle flexone">
            <h2 className="flextwo ">Confident You: Believe In Yourself <ul className="ml-3">
              <li className=""><img src={image.badges_icons1} alt="badgesicon" className="icon"/></li>
              <li><img src={image.badges_icons2} alt="badgesicon" className="icon" /></li>
              <li className="opacitydwn"><img src={image.badges_icons3} alt="badgesicon" className="icon" /></li>
              <li className="opacitydwn"><img src={image.badges_icons4} alt="badgesicon" className="icon" /></li>
            </ul></h2>

            <span className="dropdwnicon"><i class="fa-regular fa-angle-down"></i></span>
          </div>
         
        </div>
     
        <div className="LeftpanelContent">
        <div className="panneltitlesAssets flexone">
             <p className="p-2"> 
              <span>Sessions Per Week: Four (4)</span> <span className="pipe"> | </span>
              <span>Duration Per Session: 30 minutes</span>
              </p>
              <p className="p1"><a href="#"><i class="fa-solid fa-pencil mr-3"></i>Edit Plan</a></p>
          </div>
           <div className="coursecard_list">
            <div className="coursecard Active_running_course">
              <div className="skils_dimName">
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
                <div className="course_name pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>
                <div className="text-right coursebadgelist">
                <ul class="ml-3">
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Navigator.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Perspective+Master.png" alt="badgesicon" class="icon" /></li>

                </ul>
               
                </div>
             
                <div className="course_progress">
                <p className="p3 textuppercase"><span className="mr-1">25%</span> progress <span className="ml-1">🎉</span></p>
                 <Line percent={25} strokeWidth={10} strokeColor="#FF9900" />
                </div>
                <div className="coursecard_footer flexone">
                  <div className="module_count">
                    <p className="p3 textuppercase"><span className="counting">2/4 </span>Modules complete</p>
                  </div>
                  <div className="Continue_reading">
                    <p className="p1 flextwo">
                     <a href="#">Continue Learning <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="coursecard ">
              <div className="skils_dimName">
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
                <div className="course_name pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>
                <div className="text-right coursebadgelist">
                <ul class="ml-3">
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Navigator.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Perspective+Master.png" alt="badgesicon" class="icon" /></li>

                </ul>
               
                </div>
             
                <div className="course_progress">
                <p className="p3 textuppercase"><span className="mr-1">25%</span> progress <span className="ml-1">🎉</span></p>
                 <Line percent={25} strokeWidth={10} strokeColor="#FF9900" />
                </div>
                <div className="coursecard_footer flexone">
                  <div className="module_count">
                    <p className="p3 textuppercase"><span className="counting">2/4 </span>Modules complete</p>
                  </div>
                  <div className="Continue_reading">
                    <p className="p1 flextwo">
                     <a href="#">Continue Learning <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="coursecard ">
              <div className="skils_dimName">
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
                <div className="course_name pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>
                <div className="text-right coursebadgelist">
                <ul class="ml-3">
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Navigator.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Perspective+Master.png" alt="badgesicon" class="icon" /></li>

                </ul>
               
                </div>
             
                <div className="course_progress">
                <p className="p3 textuppercase"><span className="mr-1">25%</span> progress <span className="ml-1">🎉</span></p>
                 <Line percent={25} strokeWidth={10} strokeColor="#FF9900" />
                </div>
                <div className="coursecard_footer flexone">
                  <div className="module_count">
                    <p className="p3 textuppercase"><span className="counting">2/4 </span>Modules complete</p>
                  </div>
                  <div className="Continue_reading">
                    <p className="p1 flextwo">
                     <a href="#">Continue Learning <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          <div className="coursecard ">
              <div className="skils_dimName">
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
                <div className="course_name pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>
                <div className="text-right coursebadgelist">
                <ul class="ml-3">
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Navigator.png" alt="badgesicon" class="icon"/></li>
                <li class="opacitydwn"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Perspective+Master.png" alt="badgesicon" class="icon" /></li>

                </ul>
               
                </div>
             
                <div className="course_progress">
                <p className="p3 textuppercase"><span className="mr-1">25%</span> progress <span className="ml-1">🎉</span></p>
                 <Line percent={25} strokeWidth={10} strokeColor="#FF9900" />
                </div>
                <div className="coursecard_footer flexone">
                  <div className="module_count">
                    <p className="p3 textuppercase"><span className="counting">2/4 </span>Modules complete</p>
                  </div>
                  <div className="Continue_reading">
                    <p className="p1 flextwo">
                     <a href="#">Continue Learning <i class="fa-solid fa-arrow-right-long ml-3"></i></a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle">
            <h2>In Focus</h2>
          </div>
          </div>
          <div className="rightpanelContent">
             
             <div className="modules_contentList">
             <h3 className="mb-4">Emotional You: Managing Your Emotions</h3>
              <div className="modulesitems">
              <div className="progess_navigation absolute">
                <span className="circleone"><i class="fa-solid fa-check"></i></span>
              </div>
              <h4>Module 1: Self-Talk & Mindset</h4>
                <ul>
                  <li className="w-100"><span>Lesson 1</span>: What is confidence?</li>
                  <li className="w-100"><span>Lesson 2</span>: Your Inner Voice</li>
                  <li className="w-100"><span>Lesson 3</span>: Self-talk Activity</li>
                </ul>
                <p><a href="#">See All</a></p>
              </div>
              <div className="modulesitems ">
              <div className="progess_navigation absolute">
                <span className="circleone"><i class="fa-solid fa-spinner-scale"></i></span>
              </div>
                <h4>Module 2: Self-Talk & Mindset</h4>
                <ul>
                  <li className="w-100"><span>Lesson 1</span>: What is confidence?</li>
                  <li className="w-100 Active_lesson"><span>Lesson 2</span>: Your Inner Voice</li>
                  <li className="w-100 inactive_lession"><span>Lesson 3</span>: Self-talk Activity</li>
                </ul>
              </div>
              <div className="modulesitems locked_modules">
              <div className="progess_navigation absolute">
                <span className="circleone"><i class="fa-solid fa-lock-keyhole"></i></span>
              </div>
                <h4>Module 2: Self-Talk & Mindset</h4>
                
              </div>
              <div className="modulesitems locked_modules">
              <div className="progess_navigation absolute">
                <span className="circleone"><i class="fa-solid fa-lock-keyhole"></i></span>
              </div>
                <h4>Module 4: Building Habits</h4>
               
              </div>
             </div>

          </div>
      </div>
     </div>  */}
       <div className="Content_part flexsix w-100 maincontentpart coursedetailslayout">
      <div className="leftpannel pt-4">
      <div className="myplan_listitems">
        <div className="panneltitles ">
          <div className="contenttitle flexone">
            <h2 className="flextwo "><span>Module 1 <i class="fa-sharp fa-regular fa-angle-right ml-3 mr-3"></i> </span> Lesson 1: What Are Emotions?</h2>
            <span className="mybaricons"><i class="fa-regular fa-bars"></i></span>
          </div>
         
        </div>
     
        <div className="LeftpanelContent sctleftpannel">
       <div className="sctframe">
        <div className="sctconfeti flexone">
          <span><img src={image.sct_confetti} alt="confeti" /></span>
          <div className="confetimessage">
            <h1 className="mb-2">Great Job Sam!</h1>
            <p className="p1 lighttextcolor">You Completed This Module</p>
          </div>
          <span><img src={image.sct_confetti} alt="confeti" /></span>
        </div>
        <div className="sctgratimg">
          <img src={image.Sct_communication}></img>
        </div>
       </div>
        <div className="complection_status">
          <h2 className="mb-4 ">Completion Status</h2>
               <div className="module_obj_list flexone mb-4">
                                                              <div className="objcontent w-50">
                                                                    <p class="p flextwo progess_navigation ">
                                                                        <strong className=" mr-2"><i class="fa-regular fa-badge-check"></i></strong>
                                                                        Module 1: What are emotions?
                                                                    </p>
                                                              </div>
          
                                                            
                                                              <div className={`SocialDimCard objpercentage w-40`}>
                                                                 <p class="p3 textuppercase mb-1"><span class="mr-1">100%</span>Completion! 🎊🥳🤩️🎉<span class="ml-1">
                                                                   </span></p>
                                                                 
                                                                  <Line percent={100} strokeWidth={3} strokeColor="#85b812" />
                                                              </div>
                                                           </div>
                                                            <div className="module_obj_list flexone mb-4">
                                                              <div className="objcontent w-50">
                                                                    <p class="p flextwo progess_navigation ">
                                                                        <strong className=" mr-2"><i class="fa-regular fa-badge-check"></i></strong>
                                                                        Performance
                                                                    </p>
                                                              </div>
          
                                                            
                                                              <div className={`SocialDimCard objpercentage w-40`}>
                                                                 <p class="p3 textuppercase mb-1"><span class="mr-1">7/10</span><span class="ml-1">
                                                                   </span></p>
                                                                 
                                                                  <Line percent={70} strokeWidth={3} strokeColor="#85b812" />
                                                              </div>
               </div>
        </div>
        </div>
        <div className="yourachivement planprogress_list p-0">
        <div className="badgesdetails_card">
          <h2 className="flexone mb-3 pb-3">Achievements Show Case <span><span className="earned">Earned</span> 3/4</span></h2>
          <div class="clbcarddtl pb-3  w-100"><div class="lbuserdtl flextwo w-100"><div class="lbuserimage text-center"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Gale+Roc+%E2%80%93+The+Initiator.jpg" alt="" /></div><div class="lbuserName pb-2"><h3 class="">Gale Roc – The Initiator</h3><p>  This badge proves you’re stepping up. Like the Gale Roc, you’ve moved from waiting to leading — and you’re just getting started.</p><p class="m-0"></p><p></p></div></div></div>
          <div class="clbcarddtl  w-100"><div class="lbuserdtl flextwo w-100"><div class="lbuserimage text-center"><img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Gale+Roc+%E2%80%93+The+Initiator.jpg" alt="" /></div><div class="lbuserName pb-2"><h3 class="">Gale Roc – The Initiator</h3><p>  This badge proves you’re stepping up. Like the Gale Roc, you’ve moved from waiting to leading — and you’re just getting started.</p><p class="m-0"></p><p></p></div></div></div>
        </div>
        </div>
        </div>
      </div>
     
       <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle w-100">
             <h3 className="flexone">Reflections
               <div className="ml-3 mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                 <span className={`pointsno p1`}>0</span>
               </div>
              </h3>
          </div>
          </div>
          <div className="rightpanelContent">
          <div class="knowledgechecknavigation"><ul class="false"><li class="activeQuestion   pointer"><span class="br-50">1</span></li><li class="activeQuestion  lockedquestion pointer"><span class="br-50">2</span></li><li class="activeQuestion  lockedquestion pointer"><span class="br-50">3</span></li></ul></div>
            <h3 className="h-3 fw-600 mt-4  mb-4">Staying Focused: How Did You Do?</h3>
           <div class="message_box mw-100">
           <p><img src={image.Vector_quote} alt="quote"></img></p>
           <p class="mt-3">
           <span>
           <p>
            Have you noticed when your focus drifts and found ways to handle distractions better?
           </p>
            </span>
            </p>
          </div>
          <div className="sctmessagelist">
            <ul>
              <li>
                <p className="flextwo"> <img src={image.solar_chat} className="mr-3"/>Yes! I can tell when I’m getting distracted and I know what to do to refocus.</p>
              </li>
                <li>
                <p className="flextwo"> <img src={image.solar_express} className="mr-3" />Yes! I can tell when I’m getting distracted and I know what to do to refocus.</p>
              </li>
                <li>
                <p className="flextwo"> <img src={image.solar_confounded} className="mr-3" />Yes! I can tell when I’m getting distracted and I know what to do to refocus.</p>
              </li>
            </ul>
          </div> 
           <div className="jobdone">
             <div className="jobtypeimage">
              <img src={image.Amazing_job} alt="Amazing_job" />      
              </div>
              <div className="text-center">
              <h3 className="fw-600 f-size-20 pb-1">Amazing Job Sam!</h3>
              <p className="lighttextcolor p2">You’ve started mastering your attention!</p>
              </div>
          </div>
           <div className="jobdone">
             <div className="jobtypeimage">
              <img src={image.total_normal} alt="normal_job" />      
              </div>
              <div className="text-center">
              <h3 className="fw-600 f-size-20 pb-1">That’s totally normal Sam</h3>
              <p className="lighttextcolor p2">Awareness is the first big step—keep going!</p>
              </div>
          </div>
           <div className="jobdone">
             <div className="jobtypeimage">
              <img src={image.being_honest} alt="honest_job" />      
              </div>
              <div className="text-center">
              <h3 className="fw-600 f-size-20 pb-1">Thanks for being honest Sam.</h3>
              <p className="lighttextcolor p2">This is a skill you can keep improving!</p>
              </div>
          </div> 
          <h3 className="h-3 fw-600 mt-4  mb-4">Find Your Focus Clue</h3>
           <div class="message_box mw-100">
           <p><img src={image.Vector_quote} alt="quote"></img></p>
           <p class="mt-3">
          
           <p className="mb-3">
           Sometimes we lose focus and don’t even know why. Let’s change that, Sam.
           </p>
           <ul>
            <li className="mb-2 text-left">
              <p className="p2 "><span>1. </span>Pick one short task (like 10 minutes of reading, drawing, or homework).</p>
            </li>
            <li className="mb-2 text-left">
              <p className="p2 "><span>2. </span>Before you start, write down how focused you feel (1 = not focused at all, 5 = super focused).</p>
            </li>
            <li className="mb-2 text-left">
              <p className="p2 "><span>3. </span>After you finish, rate it again. What changed? Did anything distract you?</p>
            </li>
           </ul>
            </p>
            <p>This helps you notice your patterns—and that’s the first step to improving them. Tell #parent-name what you discovered!</p>
          </div>
          <div className="sctmessagelist">
            <ul>
              <li>
                <p className="flextwo"> <img src={image.starvector} className="mr-3"/>Yes! I can tell when Im getting distracted and I know what to do to refocus.</p>
              </li>
                <li>
                <p className="flextwo"> <img src={image.solar_skip} className="mr-3" />Yes! I can tell when Im getting distracted and I know what to do to refocus.</p>
              </li>
                <li>
                <p className="flextwo"> <img src={image.solar_sleeping} className="mr-3" />Yes! I can tell when Im getting distracted and I know what to do to refocus.</p>
              </li>
                 <li>
                <p className="flextwo"> <img src={image.solar_verified} className="mr-3" />Yes! I can tell when Im getting distracted and I know what to do to refocus.</p>
              </li>
            </ul>
          </div>
           <div className="jobdone">
             <div className="jobtypeimage">
              <img src={image.Amazing_job} alt="Amazing_job" />      
              </div>
              <div className="text-center">
              <h3 className="fw-600 f-size-20 pb-1">Amazing Job Sam!</h3>
              <p className="lighttextcolor p2">You’ve started mastering your attention!</p>
              </div>
          </div>
           <div className="jobdone">
             <div className="jobtypeimage">
              <img src={image.Amazing_job} alt="normal_job" />      
              </div>
              <div className="text-center">
              <h3 className="fw-600 f-size-20 pb-1">That’s okay Sam.</h3>
              <p className="lighttextcolor p2">You’re building awareness, and that takes time—keep going!</p>
              </div>
          </div>
          </div>
      </div> 
     </div>  
   <div className="Content_part flexsix w-100 maincontentpart">
      {/* <div className="leftpannel min-width-100">
      <div className="myplan_listitems">
         <div className="panneltitles ">
          <div className="contenttitle flexone">
            <h2 className="flextwo ">Choose The Right Plan For Your Child</h2>
            <span className="mybaricons"><i class="fa-regular fa-bars"></i></span>
          </div>
         
        </div> 
     
        <div className="LeftpanelContent">
        <div className="coursecatalogcontainer">
      
         <div className="mytabList  mb-3">
          <ul>
            <li className="w-33 text-center Active_tab">Choose By Developmental Area</li>
            <li className="w-33 text-center">Navigate a Life Event</li>
            <li className="w-33 text-center">Match by Concerns or Challenges</li>
          </ul>
         </div>
        
      <div className="course_catalogfilstes">
         <h2>Want Your Child To Work On A Specific Developmental Area/Skill Set?</h2>
         <p className="p2 lighttextcolor mt-3" >Already know the kind of skills your child needs? Start by picking a growth area—like Social or Emotional—and then choose specific skills to see the best course matches. The right courses will appear dynamically below.</p>
      
        <div className="developmentarea">
        <div className="populattags">
            <ul>
              <li className="tagitems">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <span className="tagName">Most Popular Courses</span>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
             
              </li>
                      <li className="tagitems">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
            <span className="tagName">Regulating Stress & Emotions</span>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
                
              </li>
                  <li className="tagitems">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
              <span className="tagName">Processing Fear And Stress</span>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
              
              </li>
                   <li className="tagitems">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
            <span className="tagName">Boosting Confidence & Resiliance</span>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
           
              </li>
          
            </ul>
        </div>
     <div className="dimtagcontainer">
        <div className="dimensiontagsList mt-4 px-4 py-2">
        <h3 className="flexone pb-4"><span className="flexthree"><img src={image.courselevel4} className="mr-4" /> Social</span> <span class="dropdwnicon pointer flexfive" href="#showUserPlan0" aria-expanded="true"><i class="fa-regular fa-chevron-down"></i></span> </h3>
          <ul className="mt-3">
            <li className="dimtagitems">
              <span>Conflict Resolution</span>
            </li>
             <li className="dimtagitems">
              <span>Effective Communication</span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Relationship Management</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Leadership</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
          </ul>
        </div>
         <div className="dimensiontagsList mt-4 px-4 py-2">
        <h3 className="flexone pb-4"><span className="flexthree"><img src={image.courselevel4} className="mr-4" /> Emotional</span> <span class="dropdwnicon pointer flexfive" href="#showUserPlan0" aria-expanded="true"><i class="fa-regular fa-chevron-down"></i></span> </h3>
          <ul className="mt-3">
            <li className="dimtagitems">
              <span>Conflict Resolution</span>
            </li>
             <li className="dimtagitems">
              <span>Effective Communication</span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Relationship Management</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Leadership</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
          </ul>
        </div>
         <div className="dimensiontagsList mt-4 px-4 py-2">
        <h3 className="flexone pb-4"><span className="flexthree"><img src={image.courselevel4} className="mr-4" /> Intellectual</span> <span class="dropdwnicon pointer flexfive" href="#showUserPlan0" aria-expanded="true"><i class="fa-regular fa-chevron-down"></i></span> </h3>
          <ul className="mt-3">
            <li className="dimtagitems">
              <span>Conflict Resolution</span>
            </li>
             <li className="dimtagitems">
              <span>Effective Communication</span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Relationship Management</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Leadership</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
          </ul>
        </div>
         <div className="dimensiontagsList mt-4 px-4 py-2">
        <h3 className="flexone pb-4"><span className="flexthree"><img src={image.courselevel4} className="mr-4" /> Mindfulness</span> <span class="dropdwnicon pointer flexfive" href="#showUserPlan0" aria-expanded="true"><i class="fa-regular fa-chevron-down"></i></span> </h3>
          <ul className="mt-3">
            <li className="dimtagitems">
              <span>Conflict Resolution</span>
            </li>
             <li className="dimtagitems">
              <span>Effective Communication</span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Relationship Management</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Leadership</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
          </ul>
        </div>
         <div className="dimensiontagsList mt-4 px-4 py-2">
        <h3 className="flexone pb-4"><span className="flexthree"><img src={image.courselevel4} className="mr-4" /> Physical</span> <span class="dropdwnicon pointer flexfive" href="#showUserPlan0" aria-expanded="true"><i class="fa-regular fa-chevron-down"></i></span> </h3>
          <ul className="mt-3">
            <li className="dimtagitems">
              <span>Conflict Resolution</span>
            </li>
             <li className="dimtagitems">
              <span>Effective Communication</span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
             <li className="dimtagitems activedimtag">
              <span>Relationship Management</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Leadership</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
            <li className="dimtagitems activedimtag">
              <span>Responsible Decision-Making</span>
              <span className="closetag ml-2"><i class="fa-regular fa-xmark"></i></span>
            </li>
          </ul>
       </div>
        </div> 
        </div>
      </div>
        </div>
        <div className="coursecatalogcontainer">
         <div className="mytabList  mb-3">
          <ul>
            <li className="w-33 text-center">Choose By Developmental Area</li>
            <li className="w-33 text-center Active_tab">Navigate a Life Event</li>
            <li className="w-33 text-center">Match by Concerns or Challenges</li>
          </ul>
         </div>
        
      <div className="course_catalogfilstes">
         <h2>Is Your Child Going Through A Major Life Event? </h2>
         <p className="p2 lighttextcolor mt-3" >
           Is your child going through something big—like a move, loss, or school change? We’ll Provide A Growth 
           Plan To Help Them Navigate This Change. Pick one life event, and we’ll guide you to a ready-made plan that helps them cope and grow.
         </p>
      
        <div className="developmentarea">
       
      <div className="dimtagcontainer">
        <div className="lifeeventlist">
       <ul>
          <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">Divorce/Separation</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
          <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">Death/Loss</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
           <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">Blended Families</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
               <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">Sibling Rivalry</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
               <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">Health Problems</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
               <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">Peer Pressure</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>

              </ul>
              <div className="buttonFooter pt-4 mt-3 text-right">
                <button className="mybutton">Recommend A Growth Plan</button>
              </div>
        
        </div>
     
        </div>
        </div>
      </div>
        </div>
          <div className="coursecatalogcontainer">
         <div className="mytabList  mb-3">
          <ul>
            <li className="w-33 text-center">Choose By Developmental Area</li>
            <li className="w-33 text-center">Navigate a Life Event</li>
            <li className="w-33 text-center Active_tab">Match by Concerns or Challenges</li>
          </ul>
         </div>
        
      <div className="course_catalogfilstes">
         <h2>Is Your Child’s Behavior Bothering You? </h2>
         <p className="p2 lighttextcolor mt-3" >
           Is your child’s behaviour bothering and concerning you? Select 2-4 concerns and challenges you’re seeing, and we’ll build a custom Growth Plan just for them!
         </p>
      
        <div className="developmentarea">
       
      <div className="dimtagcontainer">
        <div className="lifeeventlist populattags Child_challenges">
       <ul>
          <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">My Child Is Constantly Making Poor Choices</p>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
          <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">My Child Is Unaware Of Their Emotions</p>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
           <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">My Child Cares Too Much About What Other People Think</p>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
               <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">My Child Has Difficulty Outside Of Their Comfort Zone</p>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
               <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
               <p className="">My Child Consistently Makes Poor Life Choices</p>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>
          <li className="">
            <div className="Ansoptions">
            <label  className="selAnslabel ">
            <p className="">My Child Makes Excuses for their behaviour</p>
            <input type="checkbox"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          </li>

              </ul>
                <div className="buttonFooter pt-4 mt-3 text-right">
                <button className="mybutton">Recommend A Growth Plan</button>
              </div>
        
        </div>
     
        </div>
        </div>
      </div>
        </div>
        <div className="courselistcontainer course_catalogfilstes">
          <div className="mycourselist">
            <h2>Courses For Your Child</h2>
            <p className="p1 lighttextcolor">Browse through our courses and find the best fit. Filter out courses from above.</p>
          </div>
          <div className="mycoursecataloglist pdt-4">
           <div className="coursecard coursecatcard min-width-100">
              <div className="skils_dimName">
              <div className="cardcimensionicon">
                <img src={image.courselevel3} alt="dimicon" />
              </div>
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
               <div className="course_name pt-0 pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>     
                </div>
               <div className="course_objective ">
                <h3 className=" mb-3 pb-2 pt-0">📊 Course Objectives:</h3>
                <ul>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                </ul>
               </div>
              
                <div className="coursecard_footer flexone">
                  <div className="module_count lighttextcolor">
                   <span>Modules: 4</span><span>lessons: 36</span>
                  </div>
                  <div className="cardbutton_footer">
                   <button className="mybutton learnmore">Learn More</button>
                   <button className="mybutton">Enroll Now</button>
                  </div>
                </div>
              </div>
                <div className="coursecard coursecatcard min-width-100">
              <div className="skils_dimName">
              <div className="cardcimensionicon">
                <img src={image.courselevel2} alt="dimicon" />
              </div>
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
               <div className="course_name pt-0 pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>     
                </div>
               <div className="course_objective ">
                <h3 className=" mb-3 pb-2 pt-0">📊 Course Objectives:</h3>
                <ul>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                </ul>
               </div>
              
                <div className="coursecard_footer flexone">
                  <div className="module_count lighttextcolor">
                   <span>Modules: 4</span><span>lessons: 36</span>
                  </div>
                  <div className="cardbutton_footer">
                   <button className="mybutton learnmore">Learn More</button>
                   <button className="mybutton">Enroll Now</button>
                  </div>
                </div>
              </div>
                <div className="coursecard coursecatcard min-width-100">
              <div className="skils_dimName">
              <div className="cardcimensionicon">
                <img src={image.CollegeJourneyicon} alt="dimicon" />
              </div>
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
               <div className="course_name pt-0 pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>     
                </div>
               <div className="course_objective ">
                <h3 className=" mb-3 pb-2 pt-0">📊 Course Objectives:</h3>
                <ul>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                </ul>
               </div>
              
                <div className="coursecard_footer flexone">
                  <div className="module_count lighttextcolor">
                   <span>Modules: 4</span><span>lessons: 36</span>
                  </div>
                  <div className="cardbutton_footer">
                   <button className="mybutton learnmore">Learn More</button>
                   <button className="mybutton">Enroll Now</button>
                  </div>
                </div>
              </div>
           <div className="coursecard coursecatcard min-width-100">
              <div className="skils_dimName">
              <div className="cardcimensionicon">
                <img src={image.courselevel4} alt="dimicon" />
              </div>
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
               <div className="course_name pt-0 pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>     
                </div>
               <div className="course_objective ">
                <h3 className=" mb-3 pb-2 pt-0">📊 Course Objectives:</h3>
                <ul>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                </ul>
               </div>
              
                <div className="coursecard_footer flexone">
                  <div className="module_count lighttextcolor">
                   <span>Modules: 4</span><span>lessons: 36</span>
                  </div>
                  <div className="cardbutton_footer">
                   <button className="mybutton learnmore">Learn More</button>
                   <button className="mybutton">Enroll Now</button>
                  </div>
                </div>
              </div>
             <div className="coursecard coursecatcard min-width-100">
              <div className="skils_dimName">
              <div className="cardcimensionicon">
                <img src={image.courselevel5} alt="dimicon" />
              </div>
              <div className="flexone">
                <ul className="flextwo">
                  <li className="flexfive"><span><img src={image.CourseTitleIcon} alt="Dimension_icon"/></span>emotional</li>
                  <li className="flexfive"><span> <img src={image.skillsnewicon} alt="skillicon"/> </span>self-confidence</li>
                </ul>
                <div className="mypoints flexthree">
                  <img src={image.point_bag} alt="pointbag" />
                  <span className="pointsno p1">41</span>
                </div>
                 </div>
                </div>
               <div className="course_name pt-0 pb-0">
                  <h3>Emotional You: Managing Your Emotions</h3>     
                </div>
               <div className="course_objective ">
                <h3 className=" mb-3 pb-2 pt-0">📊 Course Objectives:</h3>
                <ul>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                  <li className="lighttextcolor mb-3 flextwo"><img src={image.checkicons} alt="check" /><strong>Understand Emotions:</strong> Recognize how feelings influence thoughts, behaviors, and relationships.</li>
                </ul>
               </div>
              
                <div className="coursecard_footer flexone">
                  <div className="module_count lighttextcolor">
                   <span>Modules: 4</span><span>lessons: 36</span>
                  </div>
                  <div className="cardbutton_footer">
                   <button className="mybutton learnmore">Learn More</button>
                   <button className="mybutton">Enroll Now</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>









         <div className="aboutcourseconatnr p-2">

        
        <div className="next_prevlist w-100 flex mt-3 pt-3">
          <a href="#"><i class="fa-regular fa-arrow-left mr-2"></i> Previous Lesson</a>
          <a href="#">Next Lesson <i class="fa-regular fa-arrow-right ml-2"></i></a>
        </div>
        <div className="coursedetails mt-4 pt-3">
        <div className="flexone mb-3 ">
          <div className="About_course_name">
            <h3>About The Course</h3> 
          </div>
          <div className="flextwo">
            <div className="items_image mr-3">
              <img src={image.userProfile} alt="character_image" className="br-50 " />
            </div>
            <div className="aboutitemsdtl">
              <h4>Dr Corina Weir</h4>
            </div>
            </div>
        </div>
        <div>
        <div className="course_progress">
        <div className="w-40">
           <p className="p3 textuppercase"><span className="mr-1">25%</span> progress <span className="ml-1">🎉</span></p>
           <Line percent={50} strokeWidth={10} strokeColor="#FF9900" />
         </div>
                 <p className="p2 light_paragraptxt ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
        </div>
        <div className="modulelist mt-3 pt-2">
          <div className="modulelistitem mb-3">
            <h4><span className="play_icon"><i class="fa-solid fa-circle-play mr-2"></i></span>Module 1: What are emotions?</h4>
            <p className="p2 light_paragraptxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
          </div>
           <div className="modulelistitem mb-3 locked_modules">
            <h4><span className=""><i class="fa-solid fa-lock-keyhole mr-2"></i></span>Module 1: What are emotions?</h4>
            <p className="p2 light_paragraptxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
          </div>
           <div className="modulelistitem mb-3 locked_modules">
            <h4><span className=""><i class="fa-solid fa-lock-keyhole mr-2"></i></span>Module 1: What are emotions?</h4>
            <p className="p2 light_paragraptxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
          </div>
           <div className="modulelistitem mb-3  locked_modules">
            <h4><span className=""><i class="fa-solid fa-lock-keyhole mr-2"></i></span>Module 1: What are emotions?</h4>
            <p className="p2 light_paragraptxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
          </div>
        </div>
       <div className="refrencelist br-10 border3 pt-3">
        <p className="p3 light_paragraptxt mb-2">REFERENCES:</p>
        <a href="https://fontawesome.com/icons/circle-play?f=classic&s=solid" className="light_paragraptxt mb-1">https://fontawesome.com/icons/circle-play?f=classic&s=solid</a>
        <a href="https://fontawesome.com/icons/circle-play?f=classic&s=solid" className="light_paragraptxt mb-1">https://fontawesome.com/icons/circle-play?f=classic&s=solid</a>
        <a href="https://fontawesome.com/icons/circle-play?f=classic&s=solid" className="light_paragraptxt mb-1">https://fontawesome.com/icons/circle-play?f=classic&s=solid</a>
        <a href="https://fontawesome.com/icons/circle-play?f=classic&s=solid" className="light_paragraptxt ">https://fontawesome.com/icons/circle-play?f=classic&s=solid</a>
       </div>
        </div>
        </div>
         </div> 
        </div>
        </div> */}
      </div>
       {/* <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle">
            <h2>How It Work</h2> 
          </div>
          </div>
          <div className="rightpanelContent">
           <div className="locked_Content">  
          
           <p className="p1">Complete the video lesson to unlock exercises!</p>
           
          
           </div>
          </div>
      </div>  
        <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle">
            <h2>Benefits of Healthy Relationships</h2> 
          </div>
          </div>
          <div className="rightpanelContent">
           <div className="real_world_app">  
           <div className="rwaContentstxt">
           <p className="p2">
            Sed ut perspiciatis unde omnis iste natus error sit volup accusantium doloremque laudantium, totam rem ape,
            eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim 
            ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            </p>
          
            <p className="p2">
            Sed ut perspiciatis unde omnis iste natus error sit volup accusantium doloremque laudantium, totam rem ape,
             eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
            </p>
           </div>
           
           </div>
          </div>
      </div> 
         <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle">
            <h2>Knowledge Check</h2> 
          </div>
          </div>
          <div className="rightpanelContent">
           <div className="knowledgechecknavigation">
            <ul className="flex">
              <li className=" activeQuestion complteQuestion w-auto"><span className="br-50">1</span></li>
              <li className=" activeQuestion br-50 "><span className="br-50">2</span></li>
              <li className=" activeQuestion lockedquestion br-50 "><span className="br-50">3</span></li>
            </ul>
           </div>
           <div className="message_box mw-100">
           <p><img src={image.Vector_quote} alt="quote" /></p>
           <p className="mt-3">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
           </div>
           <div className="knowlwdgwchwckQuestion">
            <div className="multiplaechoicequestion">
            <h4 className="mb-3">Q. Sed ut perspiciatis unde omnis iste natus error sit voluptatem?</h4>
            <div className="Ansoptions">
            <label className="selAnslabel"><p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</p>
            <input type="radio" name="knowledgecheck" checked />
            <span class="checkmark"></span>
            </label>
            </div>
            <div className="Ansoptions">
            <label className="selAnslabel"><p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
            <div className="Ansoptions">
            <label  className="selAnslabel"><p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque</p>
            <input type="radio"  name="knowledgecheck" />
            <span class="checkmark"></span>
            </label>
            </div>
          
        
            </div>
           </div>
           <div className="next_prevlist w-100 text-right mt-3">
         
          <a href="#">Next <i class="fa-regular fa-arrow-right ml-2"></i></a>
        </div>
          </div>
      </div>  
      <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle">
            <h2>Knowledge Check</h2> 
          </div>
          </div>
          <div className="rightpanelContent">
           <div className="knowledgechecknavigation">
            <ul className="flex">
              <li className=" activeQuestion complteQuestion w-auto"><span className="br-50">1</span></li>
              <li className=" activeQuestion br-50 "><span className="br-50">2</span></li>
              <li className=" activeQuestion lockedquestion br-50 "><span className="br-50">3</span></li>
            </ul>
           </div>
           <div className="message_box mw-100">
           <p><img src={image.Vector_quote} alt="quote" /></p>
           <p className="mt-3">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
           </div>
           <div className="knowlwdgwchwckQuestion">
          <div className="textareatypeQuestion">
          <h4 className="mb-3">Q. Sed ut perspiciatis unde omnis iste natus error sit voluptatem?</h4>
          <textarea id="w3review" name="w3review" className="w-100 br-18" placeholder='Write your answer...'/>
          </div>
           </div>
           <div className="next_prevlist w-100 text-right mt-3">
         
          <a href="#">Next <i class="fa-regular fa-arrow-right ml-2"></i></a>
        </div>
          </div>
      </div>    */}
     </div> 
        {/* <div className="Content_part flexfour">
      <div className="leftpannel">
      <div className="myplan_listitems">
        <div className="panneltitles ">
          <div className="contenttitle flexone">
            <h2 className="flextwo "><span>Module 1 <i class="fa-sharp fa-regular fa-angle-right ml-3 mr-3"></i> </span> Lesson 1: What Are Emotions?</h2>
            <span className="mybaricons"><i class="fa-regular fa-bars"></i></span>
          </div>
         
        </div>
     
        <div className="LeftpanelContent">
         <div className="mytabList mt-3 mb-3">
          <ul>
            <li className="w-33 text-center ">Lessons</li>
            <li className="w-33 text-center Active_tab">Characters</li>
            <li className="w-33 text-center"><i class="fa-solid fa-lock-keyhole mr-2"></i>Challenges</li>
          </ul>
         </div>
         <div className="video_container">
         <div className="video_icons">
            <img src={image.Video_btn} alt="videoicon"/>
         </div>
          <video src="https://vickyknows.s3-accelerate.amazonaws.com/scene_videos/Conflict+Resolution_Module+1_Exercise.mp4" preload="auto" controls="" controlslist="nodownload" className="w-100 br-18"></video>
         </div>
      
        </div>
        </div>
      </div>
     
      <div className="rightpannel">
      <div className="panneltitles flexone">
          <div className="contenttitle">
            <h2>Meet The Characters</h2> 
          </div>
          </div>
          <div className="rightpanelContent">
          <div className="meetthecahracterlist">
           <div className="Abotitems flextwo">
            <div className="items_image mr-3">
              <img src={image.userProfile} alt="character_image" className="br-50 " />
            </div>
            <div className="aboutitemsdtl">
              <h4>Luca</h4>
              <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
            </div>
           </div>
           <div className="Abotitems flextwo">
           <div className="items_image mr-3">
              <img src={image.userProfile} alt="character_image" className="br-50 " />
            </div>
            <div className="aboutitemsdtl">
              <h4>Luca</h4>
              <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
            </div>
           </div>
           <div className="Abotitems flextwo">
           <div className="items_image mr-3">
              <img src={image.userProfile} alt="character_image" className="br-50 " />
            </div>
            <div className="aboutitemsdtl">
              <h4>Bella</h4>
              <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
            </div>
           </div>
           <div className="Abotitems flextwo">
           <div className="items_image mr-3">
              <img src={image.userProfile} alt="character_image" className="br-50 " />
            </div>
            <div className="aboutitemsdtl">
              <h4>Adrian</h4>
              <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
            </div>
           </div>
           <div className="Abotitems flextwo">
           <div className="items_image mr-3">
              <img src={image.userProfile} alt="character_image" className="br-50 " />
            </div>
            <div className="aboutitemsdtl">
              <h4>Josh</h4>
              <p className="p2">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.</p>
            </div>
           </div>
          </div>
          </div>
      </div> 
     </div>    */}
   
    </div> 
{/* 
    <div className="RootContent">
    <div className="Seltprofile_sec ">
      <div className="Selprofilecontnr flexfive">
        <div className="profileheader text-center bg-darks pdt-2 pdb-2 ">
          <img src={image.vicky_logo_LP} alt="logo" />
        </div>
        <div className="myporfilelistcontnr flexfive flex-wrap">
        <h1 className="w-100 text-center">Please select a profile to continue</h1>
        <div className="profileList flexfive flex-wrap">
          <div className="profileItem">
          <div className="myprofile_image">
            <img src={image.userProfile} alt="profile" className="br-50 w-100" />
            </div>
            <div className="My_Profile">
            <p className="p1">Parent Profile <i class="fa-regular fa-arrow-right ml-3"></i></p>
            </div>
          </div>
            <div className="profileItem ">
             <div className="myprofile_image">
            <img src={image.user} alt="profile" className="br-50 w-100" />
             </div>
            <div className="My_Profile">
            <p className="p1">Alex Jr <i class="fa-regular fa-arrow-right ml-3"></i></p>
            </div>
          </div>
            <div className="profileItem ">
             <div className="myprofile_image">
            <img src={image.userProfile} alt="profile" className="br-50 w-100" />
            </div>
            <div className="My_Profile">
            <p className="p1">Girl Jr <i class="fa-regular fa-arrow-right ml-3"></i></p>
            </div>
            </div>
            <div className="profileItem ">
             <div className="myprofile_image  dashedborder br-50">
        
            <i class="fa-thin fa-circle-plus"></i>
            </div>
            <div className="My_Profile">
            <p className="p1">Add Learner<i class="fa-regular fa-arrow-right ml-3"></i></p>
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* <div className="RootContent">
      <div className="hubSpotthemeSec">
        <SecHeader />
        <div className="content-wrapper container-fluid">
        <div className="contentContainer">
          <div className="pricingcardlist text-center">
         <h1>Pricing Plans</h1>
          <div class="chooseSubscription">
          <div class="form-check form-switch d-flex justify-content-center text-center p-0 subscriptionChoose">
          <label class="form-check-label d-flex w-90 m-auto p-0 justify-content-center" for="flexSwitchCheckDefault">
          <h2>
            <span className="subsActive">Monthly</span>
            <span class="position-relative">Annually <span class="saveuptomsg">Save 17% per year</span></span>
           </h2>
            <input class="form-check-input pointer" type="radio" id="planType" />
          </label>
           
            </div>
          </div> 
          <div className="text-center flexfive">
          <div className="pricing_card">
            <h3>Single Child - Monthly</h3>
            <h2>$19.99</h2>
            <h4>Per Month</h4>
            <ul>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
            </ul>
            <p>
              <a href="#">Choose Package</a>
            </p>
          </div>
           <div className="pricing_card">
            <h3>Family - Monthly</h3>
            <h2>$29.99</h2>
            <h4>Per Month</h4>
            <ul>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
              <li><img src={image.checkcutted} />Unlimited access to all content</li>
            </ul>
            <p>
              <a href="#">Choose Package</a>
            </p>
          </div>
          </div>
         </div>
        <div className="pricingcardlist">
         <h1>Subscription: Payment Information</h1>
          
          <div className="Subscription_formcontnr pt-3">
            <h3>Payment Method</h3>
            <p>Please fill the required information</p>
            <div className="form_Subs">
              <div class="input-group">
              <label>Card Holder Name<span class="mandatoryField">*</span></label>
              <div class="form-group">
              <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
              </div>
              </div>
           <div class="input-group">
           <label>Card Number<span class="mandatoryField">*</span>
             <img src="/static/media/credit_card.f4eae5050a2093cf0988.png" /></label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
           <div className="flexone">
              <div class="input-group w-48">
           <label>Expiry Date<span class="mandatoryField">*</span>
             </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
             <div class="input-group w-48">
           <label>CVV<span class="mandatoryField">*</span>
           </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
           </div>
            <h3 className="pdb-2">Billing Address</h3>
             <div class="input-group">
           <label>Address 1<span class="mandatoryField">*</span>
            </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
          
            <div class="input-group">
           <label>Address 2(Optional)
            </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
            <div class="input-group">
           <label>City<span class="mandatoryField">*</span>
            </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
            <div class="input-group">
           <label>State<span class="mandatoryField">*</span>
            </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
            <div class="input-group">
           <label>Country<span class="mandatoryField">*</span>
            </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
               <div class="input-group">
             <label>Zipcode<span class="mandatoryField">*</span>
            </label>
             <div class="form-group">
             <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
           </div>
           </div>
           </div>
           <div class="cardbutton_footer mt-4 text-right">
              <button class="mybutton learnmore">Back</button>
              <button class="mybutton"> Subscribe</button></div>
            </div>
            </div>
          </div>
             <div className="pricingcardlist">
           <h1>Subscription: Summary</h1>
          
          <div className="Subscription_formcontnr pt-3">
            <h3 className="flexone fw-700">Subscription <i class="fa-regular fa-pen-to-square"></i></h3>
            <div className="flexone pdt-2">
              <div className="w-48 myplanbrife">
                <h3 className="fw-700">Your Plan</h3>
                <p>Family - Monthly</p>
              </div>
               <div className="w-48 myplanbrife">
                <h3 className="fw-700">Price</h3>
                <p>$29.99</p>
              </div>
            </div>
           
            <div className="form_Subs">
              <div class="input-group w-90">
              <label>Promo code<span class="mandatoryField">*</span></label>
              <div class="form-group">
              <input type="text" maxlength="100" class="form-control " placeholder="Your Name..." name="firstName" />
              </div>
              </div>
             <div class="input-group w-10 applypromocode pl-2">  
              <div class="form-group">
              <button class="mybutton"> Apply</button>
              </div>
              </div>
            <h3 className="flexone">Card Details <i class="fa-regular fa-pen-to-square"></i></h3>
           <div className="flexone pdt-2 flex-wrap">
              <div className="w-48 myplanbrife">
                <h3 className="fw-700">Card Holder Name</h3>
                <p>Ateet</p>
              </div>
               <div className="w-48 myplanbrife">
                <h3 className="fw-700">Card Number</h3>
                <p>**** **** **** 1234</p>
              </div>
               <div className="w-48 myplanbrife">
                <h3 className="fw-700">Expiry Date</h3>
                <p>12/30</p>
              </div>
            </div>
              <h3 className="fw-700">Terms & Conditions (Ts&Cs)</h3>
              <div className="termand_condition">
                <ul>
                  <li>
                 <span>1. </span>   Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
                   </li> <li>
                    <span>1. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
  </li> <li>
   <span>2. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
  </li> <li>
   <span>3. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
  </li> <li>
   <span>4. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
  </li> <li>
   <span>5. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
  </li> <li>
   <span>6. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
  </li> <li>
   <span>7. </span>
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                  </li>
                </ul>
                <div class="mt-4 parentdob"><label for="tnc" class="Selcheckbox Qwrongopton">
                <span class="QQtitle">Above Ts&Cs govern your subscription to our services. By subscribing, you agree to abide by these Ts&Cs
                <span class="mandatoryField">*</span>
                </span>
                <input id="tnc" type="checkbox" class="mr-2 termBox" /><span class="checkmark"></span></label>
                </div>

              </div>
              <div class="cardbutton_footer mt-4 text-right">
              <button class="mybutton learnmore">Back</button>
              <button class="mybutton"> Subscribe</button></div>
            </div>
          </div>
         </div>
         </div> 
        
         </div>
       
        <div class="footer-area">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-3">
   <div class="single-footer-widget">
	<a class="logo" href="https://softwarehouse.today/projects/bloomster/">
    <img src="https://softwarehouse.today/projects/bloomster/wp-content/uploads/2025/04/bloomster-logo-updated.png" alt="Bloomster" />
	</a>
	<p>With so much to do, we know your children come first. Let Bloomster help with fun, engaging educational videos, so you can tackle the rest while supporting them.</p>
		</div>
      </div>
      <div class="single-footer-widget col-lg-3 col-md-3 widget_nav_menu">
        <h3>Quick Links</h3><div class="menu-quick-links-container">
        <ul id="menu-quick-links" class="">
          <li id="menu-item-6583" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6583"><a href="https://bloomster.com/course-library">Courses</a></li>
          <li id="menu-item-7561" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7561"><a href="https://bloomster.com/online-platform">How Bloomster Works</a></li>
          <li id="menu-item-6585" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6585"><a href="https://bloomster.com/pricing">Pricing</a></li>
          <li id="menu-item-6586" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6586"><a href="https://bloomster.com/classroom">Bloomster for Schools</a></li>
        </ul>
        </div>
      </div>
      <div class="single-footer-widget col-lg-3 col-md-3 widget_nav_menu"><h3>Resources</h3>
        <div class="menu-resources-container"><ul id="menu-resources" class="">
          <li id="menu-item-7560" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7560"><a href="https://bloomster.com/about-us">About Us</a></li>
          <li id="menu-item-6587" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6587"><a href="https://bloomster.com/blog">Blog</a></li>
          <li id="menu-item-6588" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6588"><a href="https://bloomster.com/ebook-library">eBook Library</a></li>
          <li id="menu-item-6589" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6589"><a href="https://bloomster.com/app">Mobile App</a></li>
          <li id="menu-item-7559" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-7538 current_page_item menu-item-7559"><a href="https://bloomster.com/contact-us" aria-current="page">Contact Us</a></li>
</ul></div></div>
      <div class="single-footer-widget col-lg-3 col-md-3 widget_ecademy_contact_info"><h3>Contact Information</h3>    
        <ul class="footer-contact-info">
          <li><i class="fa-regular fa-envelope"></i> <a href="mailto:contact@bloomster.com">contact@bloomster.com</a>  </li>
         </ul>
         <ul class="social-link">
           <li>
           <a class="d-block facebook" target="_blank" href="https://www.facebook.com/bloomsterlearning"> <i class="fa-brands fa-facebook-f"></i></a>
           </li>
            <li>
            <a class="d-block instagram" target="_blank" href="https://www.instagram.com/bloomsterlearning"> <i class="fa-brands fa-instagram"></i></a>
            </li>
             <li>
                <a class="d-block" target="_blank" href="https://www.linkedin.com/company/bloomsterlearning"> <i class="fa-brands fa-linkedin-in"></i></a>
            </li>
            <li>
              <a class="d-block" target="_blank" href="https://www.tiktok.com/@bloomster.learning"> <i class="fa-brands fa-tiktok"></i></a>
            </li>
          </ul>
       </div>
    </div>
    <div class="footer-bottom-area">
							<div class="row align-items-center">
								<div class="col-lg-6 col-md-6">
																			<p>2025 Bloomster. All Rights Reserved.</p>
																	</div>

								<div class="col-lg-6 col-md-6">
									<ul id="menu-footer-menu" class=""><li id="menu-item-6581" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6581"><a href="https://bloomster.com/termsandprivacypolicy">Privacy Policy</a></li>
                   <li id="menu-item-6582" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6582"><a href="https://bloomster.com/termsandprivacypolicy">Terms of Use</a></li>
                  </ul>						
              		</div>
							</div>
						</div>
  </div>
         </div>
      </div>
    </div> */}
    </>
  )
}

export default CourseStaticPage
